import { useEffect, useState } from 'react';
import { fetchLoganActivities } from '../lib/strava.js';

/**
 * Loads Logan's Strava activities once and exposes loading/error state.
 * Filters to activities that actually have a route (a summary polyline), which
 * is what every map/visualisation on the site needs.
 */
export function useActivities() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    fetchLoganActivities()
      .then((d) => {
        if (!active) return;
        const withRoutes = (d || []).filter((a) => a.map && a.map.summary_polyline);
        setData(withRoutes);
      })
      .catch((e) => active && setError(e));
    return () => {
      active = false;
    };
  }, []);

  return { data, error, loading: !data && !error };
}
